import React, { useEffect, useState } from "react"
import { navigate } from "gatsby"
import { useQuery } from "../../hooks/useQuery"
import TinIcon from "../../images/business/new-tin.svg"
import TitleText from "./TitleText"
import BusinessTitleCard from "./BusinessCardTitle"
import ProceedButton from "./ProceedButton"
import Info from "./Info"

const TinApplication = () => {
  const [tinfees, setTinfees] = useState("5,000")
  const queryParams = useQuery("token")
  const gotoNext = () => {
    if (queryParams) {
      localStorage.setItem("mobile_token", queryParams)
      navigate("/business-support/mobile-tin-reg/start", {
        state: {
          service: "New TIN Application",
          path: "/business-support/mobile-tin-reg/start",
        },
      })
    } else {
      navigate("/business-support/verify", {
        state: {
          service: "New TIN Application",
          path: "/business-support/mobile-tin-reg/start",
        },
      })
    }
  }
  useEffect(() => {
    const storedData = localStorage.getItem("supportFees")

    if (storedData) {
      // Convert the JSON string back to an object
      const parsedData = JSON.parse(storedData)
      setTinfees(parsedData)
    } else {
      console.log("No data found in localStorage.")
    }
  }, [])

  return (
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <TitleText />
        <BusinessTitleCard
          title="New TIN"
          icon={TinIcon}
          subtitle="Apply for a new Tax identification number (TIN)."
        />
        <div className="business-suport-card p-lg-4 p-3 my-5">
          <div className="intro">
            <div className="ml-lg-4">
              <ul className="list-styled ml-lg-5 pl-lg-5">
                <li>Apply for a new Tax identification number</li>
                <li>
                  For an already registered business, credentials and
                  information would be required.
                </li>
                <li>
                  A copy of your certificate of registration and CAC application
                  form will be needed
                </li>
                <li>
                  This service cost{" "}
                  <span className="amount">₦{tinfees.newTin}</span>{' '}
                  if you already have a Sparkle Personal account.
                </li>
                <li>
                  Timeline: 4-5 working days after name approval and receipt of
                  required documents and information.
                </li>
              </ul>
            </div>

            <ProceedButton text="Proceed" handleClick={gotoNext} />
            <Info />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TinApplication
